import * as React from 'react';
import * as _ from 'lodash';
import { styled } from '../../theme';

export interface FormLayoutSection {
  key: string;
  elements: (React.JSX.Element | null)[];
}

export interface FormLayoutWidgetProps {
  sections: FormLayoutSection[];
  className?: any;
}

export const FormLayoutWidget: React.FC<FormLayoutWidgetProps> = (props) => {
  return (
    <S.Container className={props.className}>
      {_.map(props.sections, (section, idx) => {
        return (
          <React.Fragment key={section.key}>
            {_.map(section.elements, (element, index) => {
              if (element === _.last(section.elements)) {
                return <React.Fragment key={index}>{element}</React.Fragment>;
              }
              return <S.Pad key={index}>{element}</S.Pad>;
            })}
            {section === _.last(props.sections) ? null : <S.Ruler key={`divider-${idx}`} />}
          </React.Fragment>
        );
      })}
    </S.Container>
  );
};

namespace S {
  export const Container = styled.div``;

  export const Pad = styled.div`
    margin-bottom: 16px;
  `;

  export const Ruler = styled.div`
    height: 1px;
    background: ${(p) => p.theme.forms.ruler};
    margin-top: 32px;
    margin-bottom: 32px;
  `;
}
